<template>
  <HumanizEmail v-if="emailBadge === 'humaniz'" />
  <PersonalEmailUnverified v-if="emailBadge === 'unverified'" />
  <PersonalEmailVerified v-if="emailBadge === 'verified'" />
</template>

<script setup lang="ts">
import type { DeliveryMode } from '@/api/entity_types/EmailTemplate';
import HumanizEmail from './HumanizEmail.vue';
import PersonalEmailUnverified from './PersonalEmailUnverified.vue';
import PersonalEmailVerified from './PersonalEmailVerified.vue';
import { computed } from 'vue';
import { useCurrentUserStore } from '@/stores/currentUser';

type EmailBadge = 'humaniz' | 'unverified' | 'verified';

type Props = {
  deliveryMode: DeliveryMode;
};
const props = defineProps<Props>();

const userStore = useCurrentUserStore();

const emailBadge = computed((): EmailBadge | undefined => {
  if (props.deliveryMode === 'user' && !userStore.currentUser?.postmarkEmailVerified) {
    return 'unverified';
  }

  const map = new Map<DeliveryMode, EmailBadge>([
    ['system', 'humaniz'],
    ['user', 'verified'],
  ]);

  return map.get(props.deliveryMode);
});
</script>
